// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Banner {
  position: relative;
  width: 100%;
  /* make the banner a normal top section instead of full viewport */
  height: auto;
  /* Make the banner much shorter: clamp the height so it scales with viewport
    but stays small (roughly ~25% of the viewport height). This keeps the
    video visually compact while object-fit:cover crops as needed. */
  height: clamp(96px, 24vh, 220px);
  /* hide overflow so background video can be zoomed without showing edges */
  overflow: hidden;
  /* let the video and poster control the visible area; keep background transparent */
  background: transparent;
}

/* Make the PageSection that contains the hero banner full-bleed so the video
   can reach the very edges of the viewport without surrounding white margins. */
.PageSection--hero {
  margin: 0; /* remove outer margins */
  padding: 0; /* remove internal padding so banner can occupy the full area */
  background: transparent; /* let the banner control its background */
}

/* Compensate for the .SiteContent top margin so the hero sits flush with the page top. 
   Index.css sets .SiteContent { margin: 24px 0 }, so negate that here. */
.PageSection--hero {
  margin-top: -24px;
}

/* Background video that covers the banner area */
.Banner-bg-video {
  /* Fill the banner container at all viewport sizes. Using inset + width/height
     ensures the video always covers the full width/height and \`object-fit: cover\`
     crops as needed while preserving aspect ratio. This is more predictable than
     manually scaling via transforms. */
  position: absolute;
  inset: 0; /* top:0; right:0; bottom:0; left:0 */
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 50%; /* bias visible area downward */
  z-index: 0; /* behind banner content */
  pointer-events: none;
  display: block;
}

.Banner-title {
  /* Move the small team label to the top-left corner of the banner section. */
  position: absolute;
  top: 24px;
  left: 24px;
  z-index: 5;
  color: #000; /* make the banner title black */
  margin: 0;
  font-size: 2.25rem;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap; /* keep the label on a single line on wider viewports */
}

/* Glass-style rounded pill behind the inline logo + team label */
.Banner-title::before {
  content: "";
  position: absolute;
  /* extend slightly around the title to form a pill */
  top: -8px;
  bottom: -8px;
  left: -20px;
  right: -20px;
  border-radius: 999px;
  /* whiter, frosty glass: brighter veil, stronger inset highlight, lower color saturation */
  background: linear-gradient(180deg, rgba(255,255,255,0.30), rgba(255,255,255,0.16));
  border: 1px solid rgba(255,255,255,0.22);
  box-shadow: 0 16px 44px rgba(2,6,23,0.06), inset 0 2px 6px rgba(255,255,255,0.6);
  /* heavy blur but reduce saturation so it reads as white/frost rather than colored glass */
  backdrop-filter: blur(18px) saturate(85%) contrast(112%);
  -webkit-backdrop-filter: blur(18px) saturate(85%) contrast(112%);
  z-index: 4; /* sit behind the title content (title has z-index:5) */
  pointer-events: none;
  /* opacity fades first, then the pill refits (scaleX) slightly later for a staged effect */
  transition: opacity 260ms cubic-bezier(.2,.9,.2,1), transform 300ms cubic-bezier(.2,.9,.2,1) 220ms;
  will-change: opacity, transform, backdrop-filter;
}

/* Ensure the inline images, title text and subtext render above the glass pill */
.Banner-title > *,
.Banner-title .Brand-sub {
  position: relative;
  z-index: 6;
}

/* Subtle centered horizontal frosted highlight across the pill to improve readability */
.Banner-title::after {
  content: "";
  position: absolute;
  /* inset horizontally with a little breathing room so the highlight doesn't touch the pill edges */
  left: 0.06%;
  right: 0.06%;
  /* center vertically in the pill */
  top: 50%;
  transform: translateY(-50%);
  /* make it a short horizontal band */
  height: 90%;
  border-radius: 999px;
  /* strong white center that fades to transparent for a frosted streak */
  background: linear-gradient(180deg, rgba(255,255,255,0.95), rgba(255,255,255,0.18));
  /* soften with a small blur so it reads as a glow rather than a hard bar */
  filter: blur(6px);
  -webkit-filter: blur(6px);
  opacity: 0.6;
  pointer-events: none;
  /* place above the base pill (::before is z-index:4) but below the title content (children are z-index:6) */
  z-index: 5;
  transition: opacity 220ms cubic-bezier(.2,.9,.2,1), transform 300ms cubic-bezier(.2,.9,.2,1) 220ms;
}

/* Hide the glass pill when the banner is scrolled */
.Banner.banner-scrolled .Banner-title::before {
  opacity: 0;
  /* lift slightly, shift toward the left and shrink horizontally to 'refit' */
  transform: translateY(-8px) translateX(-6px) scaleX(.72) scale(.98);
}

.Banner-inner {
  max-width: 1200px;
  margin: 0 auto;
  /* reduce vertical padding so content fits the shorter banner */
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: flex-start; /* align brand to the left */
  z-index: 2;
  /* remove the extra left padding now that sections align to the navbar */
  padding-left: 0;
}

.Banner-brand {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px; /* shrink distance between logo and inline content */
  justify-content: flex-start; /* keep brand contents left-aligned */
}

.Banner {
  /* Remove dark overlay gradient so the banner doesn't create a heavy blue overlay */
  background: transparent;
  /* tunable nudge distance when moving the team label on scroll (negative = left) */
  --brand-nudge: -36px;
}

.Banner-logo {
  /* Responsive sizing: let the logo scale with viewport but never overflow its container.
     Using clamp() ensures it shrinks on narrow viewports and grows on wide ones. */
  /* Example: min 160px, scales with viewport (vw), caps at 960px */
  width: clamp(160px, 28vw, 960px);
  height: auto;
  max-width: 100%; /* keep it from overflowing its container horizontally */
  display: block;
  object-fit: contain;
}

/* Inline slim logo next to the team text */
.Banner-logo--inline {
  /* Inline (slim) logo should scale down as the viewport shrinks. */
  height: clamp(28px, 6.5vw, 72px); /* min, preferred (vw), max */
  width: auto;
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
}

/* Color blocks image placed to the left of the slim FDAO logo */
.Banner-logo--blocks {
  /* Color blocks scale responsively as well. */
  height: clamp(40px, 10vw, 120px);
  width: auto;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;  /* a touch more spacing before the slim logo */
}

/* Transitions for scroll-hide behavior: fade and slightly lift the logos */
.Banner-logo--inline,
.Banner-logo--blocks {
  transition: opacity 260ms cubic-bezier(.2,.9,.2,1), transform 260ms cubic-bezier(.2,.9,.2,1);
  will-change: opacity, transform;
}

/* When the banner receives .banner-scrolled, hide the logos smoothly */
.Banner.banner-scrolled .Banner-logo--inline,
.Banner.banner-scrolled .Banner-logo--blocks {
  /* fade and lift the block/logo out first */
  opacity: 0;
  transform: translateY(-8px) scale(.96);
  pointer-events: none;
}

/* Hide the highlight along with the pill when scrolled */
.Banner.banner-scrolled .Banner-title::after {
  opacity: 0;
  transform: translateY(-60%) translateX(-6px) scaleX(.72) scale(.98);
}

.Brand-main {
  font-weight: 700;
  font-size: 2.25rem;
  color: #000; /* primary brand text should be black */
}

.Brand-sep {
  color: #000; /* separator in black */
  font-weight: 600;
  margin: 0 6px;
}

.Brand-sub {
  font-weight: 500;
  font-size: 1.2rem;
  color: #111; /* slightly muted black for subtext */
  display: inline-block; /* allow transforms */
  /* animate slide then fade when banner is scrolled; small delays stage the sequence */
  transition: transform 260ms cubic-bezier(.2,.9,.2,1) 120ms, opacity 260ms cubic-bezier(.2,.9,.2,1) 140ms;
  will-change: transform, opacity;
}

/* When scrolled, nudge the team label left so it moves into the space left by the slim logo */
.Banner.banner-scrolled .Brand-sub {
  /* move left slightly and fade out so the label disappears with the other elements */
  transform: translateX(var(--brand-nudge));
  opacity: 0;
  pointer-events: none;
}

@media (max-width: 768px) {
  /* on small screens use a smaller nudge to avoid overflow */
  .Banner {
    --brand-nudge: -18px;
  }
}

/* Responsive: stack logo and title on small screens */
@media (max-width: 768px) {
  .Banner-inner {
    justify-content: center; /* center on small screens */
    padding-left: 24px; /* reset left padding for mobile */
  }

  .Banner-brand {
    flex-direction: column;
    gap: 8px;
    margin-top: 10%;
    justify-content: center;
  }

  .Banner-title {
    /* revert absolute positioning on small screens so title stacks under/over content */
    position: static;
    top: auto;
    left: auto;
    z-index: 3;
    white-space: normal; /* allow wrapping on small screens */
    flex-direction: column;
    font-size: 1.6rem;
    text-align: center;
  }

  .Brand-main {
    font-size: 1.6rem;
  }

  .Brand-sub {
    font-size: 1rem;
  }
  .Banner-logo {
    /* On small screens, allow the logo to be a percentage of the viewport but capped */
    width: clamp(120px, 50vw, 288px);
    height: auto;
    max-width: 100%;
  }

  .Banner-logo--blocks {
    height: clamp(32px, 18vw, 80px); /* smaller caps on narrow screens */
  }

  .Banner-logo--inline {
    height: clamp(24px, 12vw, 56px); /* reduce inline slim logo on mobile to avoid crowding */
  }

  /* hide background video on small screens for performance and layout stability */
  .Banner-bg-video {
    display: none;
  }
}

.content--canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

/* Hide the canvas container since animation was removed */
.content--canvas {
  display: none;
}

/* Provide a subtle static background color for the banner (already set above using variables) */`, "",{"version":3,"sources":["webpack://./src/css/Banner.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,kEAAkE;EAClE,YAAY;EACZ;;oEAEkE;EAClE,gCAAgC;EAChC,0EAA0E;EAC1E,gBAAgB;EAChB,mFAAmF;EACnF,uBAAuB;AACzB;;AAEA;gFACgF;AAChF;EACE,SAAS,EAAE,yBAAyB;EACpC,UAAU,EAAE,+DAA+D;EAC3E,uBAAuB,EAAE,0CAA0C;AACrE;;AAEA;yEACyE;AACzE;EACE,iBAAiB;AACnB;;AAEA,iDAAiD;AACjD;EACE;;;uCAGqC;EACrC,kBAAkB;EAClB,QAAQ,EAAE,qCAAqC;EAC/C,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B,EAAE,+BAA+B;EAC5D,UAAU,EAAE,0BAA0B;EACtC,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,4EAA4E;EAC5E,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW,EAAE,gCAAgC;EAC7C,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB,EAAE,uDAAuD;AAC9E;;AAEA,iEAAiE;AACjE;EACE,WAAW;EACX,kBAAkB;EAClB,oDAAoD;EACpD,SAAS;EACT,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,0FAA0F;EAC1F,mFAAmF;EACnF,wCAAwC;EACxC,gFAAgF;EAChF,0FAA0F;EAC1F,wDAAwD;EACxD,gEAAgE;EAChE,UAAU,EAAE,uDAAuD;EACnE,oBAAoB;EACpB,0FAA0F;EAC1F,kGAAkG;EAClG,gDAAgD;AAClD;;AAEA,iFAAiF;AACjF;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,wFAAwF;AACxF;EACE,WAAW;EACX,kBAAkB;EAClB,kGAAkG;EAClG,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;EACpC,WAAW;EACX,oBAAoB;EACpB,uEAAuE;EACvE,mFAAmF;EACnF,0EAA0E;EAC1E,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,2GAA2G;EAC3G,UAAU;EACV,kGAAkG;AACpG;;AAEA,oDAAoD;AACpD;EACE,UAAU;EACV,4EAA4E;EAC5E,mEAAmE;AACrE;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,+DAA+D;EAC/D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B,EAAE,4BAA4B;EACzD,UAAU;EACV,wEAAwE;EACxE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAE,oDAAoD;EAC9D,2BAA2B,EAAE,qCAAqC;AACpE;;AAEA;EACE,mFAAmF;EACnF,uBAAuB;EACvB,kFAAkF;EAClF,oBAAoB;AACtB;;AAEA;EACE;mFACiF;EACjF,iEAAiE;EACjE,gCAAgC;EAChC,YAAY;EACZ,eAAe,EAAE,wDAAwD;EACzE,cAAc;EACd,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,kEAAkE;EAClE,gCAAgC,EAAE,6BAA6B;EAC/D,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,gEAAgE;AAChE;EACE,6CAA6C;EAC7C,gCAAgC;EAChC,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB,GAAG,8CAA8C;AACrE;;AAEA,2EAA2E;AAC3E;;EAEE,4FAA4F;EAC5F,+BAA+B;AACjC;;AAEA,uEAAuE;AACvE;;EAEE,2CAA2C;EAC3C,UAAU;EACV,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA,yDAAyD;AACzD;EACE,UAAU;EACV,mEAAmE;AACrE;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW,EAAE,uCAAuC;AACtD;;AAEA;EACE,WAAW,EAAE,uBAAuB;EACpC,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW,EAAE,qCAAqC;EAClD,qBAAqB,EAAE,qBAAqB;EAC5C,qFAAqF;EACrF,wGAAwG;EACxG,+BAA+B;AACjC;;AAEA,8FAA8F;AAC9F;EACE,oFAAoF;EACpF,yCAAyC;EACzC,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,2DAA2D;EAC3D;IACE,oBAAoB;EACtB;AACF;;AAEA,sDAAsD;AACtD;EACE;IACE,uBAAuB,EAAE,4BAA4B;IACrD,kBAAkB,EAAE,kCAAkC;EACxD;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,oFAAoF;IACpF,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,UAAU;IACV,mBAAmB,EAAE,oCAAoC;IACzD,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,mFAAmF;IACnF,gCAAgC;IAChC,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,+BAA+B,EAAE,mCAAmC;EACtE;;EAEA;IACE,+BAA+B,EAAE,wDAAwD;EAC3F;;EAEA,gFAAgF;EAChF;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA,0DAA0D;AAC1D;EACE,aAAa;AACf;;AAEA,gGAAgG","sourcesContent":[".Banner {\n  position: relative;\n  width: 100%;\n  /* make the banner a normal top section instead of full viewport */\n  height: auto;\n  /* Make the banner much shorter: clamp the height so it scales with viewport\n    but stays small (roughly ~25% of the viewport height). This keeps the\n    video visually compact while object-fit:cover crops as needed. */\n  height: clamp(96px, 24vh, 220px);\n  /* hide overflow so background video can be zoomed without showing edges */\n  overflow: hidden;\n  /* let the video and poster control the visible area; keep background transparent */\n  background: transparent;\n}\n\n/* Make the PageSection that contains the hero banner full-bleed so the video\n   can reach the very edges of the viewport without surrounding white margins. */\n.PageSection--hero {\n  margin: 0; /* remove outer margins */\n  padding: 0; /* remove internal padding so banner can occupy the full area */\n  background: transparent; /* let the banner control its background */\n}\n\n/* Compensate for the .SiteContent top margin so the hero sits flush with the page top. \n   Index.css sets .SiteContent { margin: 24px 0 }, so negate that here. */\n.PageSection--hero {\n  margin-top: -24px;\n}\n\n/* Background video that covers the banner area */\n.Banner-bg-video {\n  /* Fill the banner container at all viewport sizes. Using inset + width/height\n     ensures the video always covers the full width/height and `object-fit: cover`\n     crops as needed while preserving aspect ratio. This is more predictable than\n     manually scaling via transforms. */\n  position: absolute;\n  inset: 0; /* top:0; right:0; bottom:0; left:0 */\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center 50%; /* bias visible area downward */\n  z-index: 0; /* behind banner content */\n  pointer-events: none;\n  display: block;\n}\n\n.Banner-title {\n  /* Move the small team label to the top-left corner of the banner section. */\n  position: absolute;\n  top: 24px;\n  left: 24px;\n  z-index: 5;\n  color: #000; /* make the banner title black */\n  margin: 0;\n  font-size: 2.25rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap; /* keep the label on a single line on wider viewports */\n}\n\n/* Glass-style rounded pill behind the inline logo + team label */\n.Banner-title::before {\n  content: \"\";\n  position: absolute;\n  /* extend slightly around the title to form a pill */\n  top: -8px;\n  bottom: -8px;\n  left: -20px;\n  right: -20px;\n  border-radius: 999px;\n  /* whiter, frosty glass: brighter veil, stronger inset highlight, lower color saturation */\n  background: linear-gradient(180deg, rgba(255,255,255,0.30), rgba(255,255,255,0.16));\n  border: 1px solid rgba(255,255,255,0.22);\n  box-shadow: 0 16px 44px rgba(2,6,23,0.06), inset 0 2px 6px rgba(255,255,255,0.6);\n  /* heavy blur but reduce saturation so it reads as white/frost rather than colored glass */\n  backdrop-filter: blur(18px) saturate(85%) contrast(112%);\n  -webkit-backdrop-filter: blur(18px) saturate(85%) contrast(112%);\n  z-index: 4; /* sit behind the title content (title has z-index:5) */\n  pointer-events: none;\n  /* opacity fades first, then the pill refits (scaleX) slightly later for a staged effect */\n  transition: opacity 260ms cubic-bezier(.2,.9,.2,1), transform 300ms cubic-bezier(.2,.9,.2,1) 220ms;\n  will-change: opacity, transform, backdrop-filter;\n}\n\n/* Ensure the inline images, title text and subtext render above the glass pill */\n.Banner-title > *,\n.Banner-title .Brand-sub {\n  position: relative;\n  z-index: 6;\n}\n\n/* Subtle centered horizontal frosted highlight across the pill to improve readability */\n.Banner-title::after {\n  content: \"\";\n  position: absolute;\n  /* inset horizontally with a little breathing room so the highlight doesn't touch the pill edges */\n  left: 0.06%;\n  right: 0.06%;\n  /* center vertically in the pill */\n  top: 50%;\n  transform: translateY(-50%);\n  /* make it a short horizontal band */\n  height: 90%;\n  border-radius: 999px;\n  /* strong white center that fades to transparent for a frosted streak */\n  background: linear-gradient(180deg, rgba(255,255,255,0.95), rgba(255,255,255,0.18));\n  /* soften with a small blur so it reads as a glow rather than a hard bar */\n  filter: blur(6px);\n  -webkit-filter: blur(6px);\n  opacity: 0.6;\n  pointer-events: none;\n  /* place above the base pill (::before is z-index:4) but below the title content (children are z-index:6) */\n  z-index: 5;\n  transition: opacity 220ms cubic-bezier(.2,.9,.2,1), transform 300ms cubic-bezier(.2,.9,.2,1) 220ms;\n}\n\n/* Hide the glass pill when the banner is scrolled */\n.Banner.banner-scrolled .Banner-title::before {\n  opacity: 0;\n  /* lift slightly, shift toward the left and shrink horizontally to 'refit' */\n  transform: translateY(-8px) translateX(-6px) scaleX(.72) scale(.98);\n}\n\n.Banner-inner {\n  max-width: 1200px;\n  margin: 0 auto;\n  /* reduce vertical padding so content fits the shorter banner */\n  padding: 20px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start; /* align brand to the left */\n  z-index: 2;\n  /* remove the extra left padding now that sections align to the navbar */\n  padding-left: 0;\n}\n\n.Banner-brand {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 8px; /* shrink distance between logo and inline content */\n  justify-content: flex-start; /* keep brand contents left-aligned */\n}\n\n.Banner {\n  /* Remove dark overlay gradient so the banner doesn't create a heavy blue overlay */\n  background: transparent;\n  /* tunable nudge distance when moving the team label on scroll (negative = left) */\n  --brand-nudge: -36px;\n}\n\n.Banner-logo {\n  /* Responsive sizing: let the logo scale with viewport but never overflow its container.\n     Using clamp() ensures it shrinks on narrow viewports and grows on wide ones. */\n  /* Example: min 160px, scales with viewport (vw), caps at 960px */\n  width: clamp(160px, 28vw, 960px);\n  height: auto;\n  max-width: 100%; /* keep it from overflowing its container horizontally */\n  display: block;\n  object-fit: contain;\n}\n\n/* Inline slim logo next to the team text */\n.Banner-logo--inline {\n  /* Inline (slim) logo should scale down as the viewport shrinks. */\n  height: clamp(28px, 6.5vw, 72px); /* min, preferred (vw), max */\n  width: auto;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 8px;\n}\n\n/* Color blocks image placed to the left of the slim FDAO logo */\n.Banner-logo--blocks {\n  /* Color blocks scale responsively as well. */\n  height: clamp(40px, 10vw, 120px);\n  width: auto;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;  /* a touch more spacing before the slim logo */\n}\n\n/* Transitions for scroll-hide behavior: fade and slightly lift the logos */\n.Banner-logo--inline,\n.Banner-logo--blocks {\n  transition: opacity 260ms cubic-bezier(.2,.9,.2,1), transform 260ms cubic-bezier(.2,.9,.2,1);\n  will-change: opacity, transform;\n}\n\n/* When the banner receives .banner-scrolled, hide the logos smoothly */\n.Banner.banner-scrolled .Banner-logo--inline,\n.Banner.banner-scrolled .Banner-logo--blocks {\n  /* fade and lift the block/logo out first */\n  opacity: 0;\n  transform: translateY(-8px) scale(.96);\n  pointer-events: none;\n}\n\n/* Hide the highlight along with the pill when scrolled */\n.Banner.banner-scrolled .Banner-title::after {\n  opacity: 0;\n  transform: translateY(-60%) translateX(-6px) scaleX(.72) scale(.98);\n}\n\n.Brand-main {\n  font-weight: 700;\n  font-size: 2.25rem;\n  color: #000; /* primary brand text should be black */\n}\n\n.Brand-sep {\n  color: #000; /* separator in black */\n  font-weight: 600;\n  margin: 0 6px;\n}\n\n.Brand-sub {\n  font-weight: 500;\n  font-size: 1.2rem;\n  color: #111; /* slightly muted black for subtext */\n  display: inline-block; /* allow transforms */\n  /* animate slide then fade when banner is scrolled; small delays stage the sequence */\n  transition: transform 260ms cubic-bezier(.2,.9,.2,1) 120ms, opacity 260ms cubic-bezier(.2,.9,.2,1) 140ms;\n  will-change: transform, opacity;\n}\n\n/* When scrolled, nudge the team label left so it moves into the space left by the slim logo */\n.Banner.banner-scrolled .Brand-sub {\n  /* move left slightly and fade out so the label disappears with the other elements */\n  transform: translateX(var(--brand-nudge));\n  opacity: 0;\n  pointer-events: none;\n}\n\n@media (max-width: 768px) {\n  /* on small screens use a smaller nudge to avoid overflow */\n  .Banner {\n    --brand-nudge: -18px;\n  }\n}\n\n/* Responsive: stack logo and title on small screens */\n@media (max-width: 768px) {\n  .Banner-inner {\n    justify-content: center; /* center on small screens */\n    padding-left: 24px; /* reset left padding for mobile */\n  }\n\n  .Banner-brand {\n    flex-direction: column;\n    gap: 8px;\n    margin-top: 10%;\n    justify-content: center;\n  }\n\n  .Banner-title {\n    /* revert absolute positioning on small screens so title stacks under/over content */\n    position: static;\n    top: auto;\n    left: auto;\n    z-index: 3;\n    white-space: normal; /* allow wrapping on small screens */\n    flex-direction: column;\n    font-size: 1.6rem;\n    text-align: center;\n  }\n\n  .Brand-main {\n    font-size: 1.6rem;\n  }\n\n  .Brand-sub {\n    font-size: 1rem;\n  }\n  .Banner-logo {\n    /* On small screens, allow the logo to be a percentage of the viewport but capped */\n    width: clamp(120px, 50vw, 288px);\n    height: auto;\n    max-width: 100%;\n  }\n\n  .Banner-logo--blocks {\n    height: clamp(32px, 18vw, 80px); /* smaller caps on narrow screens */\n  }\n\n  .Banner-logo--inline {\n    height: clamp(24px, 12vw, 56px); /* reduce inline slim logo on mobile to avoid crowding */\n  }\n\n  /* hide background video on small screens for performance and layout stability */\n  .Banner-bg-video {\n    display: none;\n  }\n}\n\n.content--canvas {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n}\n\n/* Hide the canvas container since animation was removed */\n.content--canvas {\n  display: none;\n}\n\n/* Provide a subtle static background color for the banner (already set above using variables) */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
